export default __webpack_public_path__ + "static/media/6N5A3876_tn.48df033f.jpg";